const secrets = {
  marketoLeadInfo: 'nbH6wzWBz2qcgx',
};

export default secrets;
